import React from 'react'
import { Globe } from 'lucide-react'
import { useLocalization } from '../hooks/useLocalization'

/**
 * Language Toggle Component
 * 
 * Toggle/selector for switching between English and Spanish
 * Uses global localization hook - no props needed
 * Can be used on any page
 */
const LanguageToggle: React.FC = () => {
  const { language, changeLanguage } = useLocalization()

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-5 h-5 text-gray-600 dark:text-gray-400" />
      <div className="flex items-center bg-gray-100 dark:bg-gray-700 rounded-lg p-1 border border-gray-200 dark:border-gray-600">
        <button
          onClick={() => changeLanguage('en')}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            language === 'en'
              ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-blue-400 shadow-sm'
              : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
          }`}
          aria-label="Switch to English"
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage('es')}
          className={`px-3 py-1.5 text-sm font-medium rounded-md transition-colors ${
            language === 'es'
              ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-blue-400 shadow-sm'
              : 'text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white'
          }`}
          aria-label="Cambiar a Español"
        >
          ES
        </button>
      </div>
    </div>
  )
}

export default LanguageToggle
